import React from "react";
import dayjs from "dayjs";
import Footer, { FooterLeft, FooterRight } from "../../../components/admin/layouts/Footer/Footer";

const DefaultFooterTemplate = () => {
  return (
    <Footer>
      <FooterLeft className="text-zinc-500">
        <div>Copyright © {dayjs().format("YYYY")}</div>
      </FooterLeft>
      <FooterRight className="text-zinc-500">
        {/* <span>
          <b>Paving Market</b> React Template
        </span> */}
      </FooterRight>
    </Footer>
  );
};

export default DefaultFooterTemplate;
